import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getErrorMessage } from '@juvare/common-web-ui/utils';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import React from 'react';
import { useAlertServiceClient } from '../../../hooks';
export const VoiceRecording = ({ id }) => {
    const alertServiceClient = useAlertServiceClient();
    const [loading, setLoading] = React.useState(false);
    const [recordingBlob, setRecordingBlob] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [showAudio, setShowAudio] = React.useState(false);
    const handleShowAudio = () => {
        setShowAudio(true);
        setLoading(true);
        alertServiceClient
            .getDocument(id)
            .then((blob) => {
            setRecordingBlob(blob);
            setLoading(false);
        })
            .catch((error) => {
            setErrorMessage(getErrorMessage(error));
            setLoading(false);
        });
    };
    if (showAudio) {
        if (errorMessage) {
            return React.createElement(Alert, { severity: 'error' }, errorMessage);
        }
        else if (loading) {
            return React.createElement(CircularProgress, null);
        }
        else {
            return (React.createElement(Box, { sx: {
                    '& audio': {
                        width: '100%',
                        backgroundColor: themeColors.surface.tertiary,
                    },
                } }, recordingBlob && (React.createElement("audio", { "data-testid": 'audio-control', "data-test": 'audio-control', preload: 'auto', controls: true, controlsList: 'nodownload', autoPlay: true },
                React.createElement("source", { src: URL.createObjectURL(recordingBlob), type: 'audio/mpeg' })))));
        }
    }
    else {
        return (React.createElement(Button, { color: 'primary', variant: 'outlined', onClick: handleShowAudio }, "PLAY"));
    }
};
